import { render } from "./ManagerGuardRequest.vue?vue&type=template&id=79bca5f6"
import script from "./ManagerGuardRequest.vue?vue&type=script&lang=js"
export * from "./ManagerGuardRequest.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__